import React from 'react';
import { Eye, Users, TrendingUp, Mail } from 'lucide-react';
import { useDashboardMetrics } from '../../hooks/useDashboardMetrics';
import { useAcmBase } from '../../hooks/useAcmBase';
import { formatNumber } from '../../utils/formatters';

export function MobileDashboard() {
  const { metrics, loading: metricsLoading } = useDashboardMetrics();
  const { totalCount, activeCount, loading: studentsLoading } = useAcmBase();

  const loading = metricsLoading || studentsLoading;

  return (
    <div className="p-4 pt-16">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-white">Dashboard</h1>
        <p className="text-gray-400 text-sm">
          {new Date().toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
          })}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-[#1A1D23] p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Eye className="w-4 h-4 text-[#268c73]" />
            <span className="text-sm text-gray-400">E-mails Abertos</span>
          </div>
          <p className="text-lg font-bold text-white">
            {loading ? "..." : formatNumber(metrics.totalOpens)}
          </p>
        </div>

        <div className="bg-[#1A1D23] p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Users className="w-4 h-4 text-[#268c73]" />
            <span className="text-sm text-gray-400">Alunos Ativos</span>
          </div>
          <p className="text-lg font-bold text-white">
            {loading ? "..." : formatNumber(activeCount)}
          </p>
        </div>

        <div className="bg-[#1A1D23] p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp className="w-4 h-4 text-[#268c73]" />
            <span className="text-sm text-gray-400">Taxa de Clique</span>
          </div>
          <p className="text-lg font-bold text-white">
            {loading ? "..." : `${metrics.clickThroughRate.toFixed(1)}%`}
          </p>
        </div>

        <div className="bg-[#1A1D23] p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Mail className="w-4 h-4 text-[#268c73]" />
            <span className="text-sm text-gray-400">E-mails Enviados</span>
          </div>
          <p className="text-lg font-bold text-white">
            {loading ? "..." : formatNumber(metrics.sentEmails)}
          </p>
        </div>
      </div>

      {/* Mais seções podem ser adicionadas aqui */}
    </div>
  );
}